import { render, staticRenderFns } from "./ContributionsHistory.vue?vue&type=template&id=28f207d5"
import script from "./ContributionsHistory.vue?vue&type=script&lang=ts"
export * from "./ContributionsHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports